import { useMutation } from '@tanstack/react-query'
import { deleteFile } from 'service/util'

function useDeleteFile() {
  return useMutation({
    mutationKey: ['delete-file'],
    mutationFn: deleteFile,
  })
}

export default useDeleteFile
